import { Component, Input, ViewChildren } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { TooltipDirective } from 'ng2-tooltip-directive';

@Component({
	selector: 'app-r103-time-of-the-day',
	templateUrl: './r103-time-of-the-day.component.html',
	styleUrls: ['./r103-time-of-the-day.component.css']
})
export class R103TimeOfTheDayComponent {
	@ViewChildren(TooltipDirective) tooltipDirective;

	@Input() key: string;
	@Input() sectiontitle: string;
	@Input() sectionclass: any;

	public hasData: boolean = true;
	public showLoad = false;
	public widgetDataSubscription: any;
	public reloadSubscription: any;
	public timezone: string = '';
	public dayPartArray = [];
	public tooltipOptions = {
		placement: 'top',
		theme: 'light'
	};

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key)
			.subscribe((response: any) => {
				this.showLoad = false;
				this.timezone = response.timezone ? `(${response.timezone})` : '';
				if (response.success && response.data.length > 0) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
	}

	processResponseData(responseData: any): void {
		var maxValue = responseData.reduce(function (prev, current) {
			return prev && parseInt(prev.impressions) > parseInt(current.impressions) ? prev : current;
		});
		var finalMaxValue = parseInt(maxValue.impressions) + 10000;
		this.dayPartArray = [];
		responseData.forEach((obj, index) => {
			var percentage = ((parseInt(responseData[index]['impressions']) / finalMaxValue) * 100).toFixed(2);
			this.dayPartArray.push({
				name: responseData[index]['daypart'],
				friendly_name: responseData[index]['friendly_name'],
				percentage: parseInt(percentage),
				impressions: responseData[index]['impressions']
			});
		});
	}
}
